import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { useNavigate, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { EMPTY_OBJECT, EMPTY_ARRAY, getSvgIcon } from '../../../constants/globalConstants'
import MiniHeader from '../MiniHeader'
import Loader from '../../../global/Loader'
import Footer from '../Footer'
import AmountPaid from '../AmountPaid'
import PaymentBreakUpDetails from '../PaymentBreakUpDetails'
import NoData from '../../NoData'
import { errorMessage } from '../../../constants/errorMessage'
import {  Col, Row } from 'react-bootstrap'
import moment from 'moment'
import QRCode from 'react-qr-code'
// import OK from '../../../assets/img/check_new.png'
import { getCardIcon, getLocation, isPromoValidateButton, notify, priceGreaterOrNot } from '../../../utils/helper'
// import direction from '../../../assets/img/direction.png'
import { getConfigDetails } from '../../../services/config'
import { getTicketDetails } from '../../../redux/actions/ReceiptsAction'
import { addEventLog } from '../../../redux/actions/EventsLog'
import CONSTANTS from '../../../redux/constants'


function ReceiptsDetails(props) {
  const { dispatch, loader } = props
  const [paymentData, setPaymentData] = useState(EMPTY_OBJECT)
  const [isDisplayDetails, setIsDisplayDetails] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [errorMsg, setError] = useState('')
  const { partner, ticket_id } = useParams()

  // confirmation modal 

  // 
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  useEffect(() => {
    const Details = JSON?.parse(localStorage?.getItem('paymentRecipt'))
    // let listItem = [{ 'headerName': 'Parking Amount', 'val': `$${Details.base_amount ? Details.base_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${Details.tax_fee ? Details.tax_fee : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${Details.processing_fee ? Details.processing_fee : '0.00'}` }]
    // if(Details?.discount_amount && Details?.discount_amount != ''){

    if ((!Details || !Details?.ticket_number) && !ticket_id) {
      const pushBack = JSON.parse(localStorage.getItem('history'))
      if(pushBack?.route && pushBack?.facility){
          navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
      }else{
          navigate(`/${partner}`)
      }
      // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
    } else {
      setIsLoading(true)
      const payload = {
        'ticket': ticket_id ? ticket_id : Details?.ticket_number,
        'phone': '',
        'cardLast4': '',
        'cardExpiry': '',
        'license_plate': '',
        'partner_id': getConfigDetails()?.PARTNER_ID,
      }
      dispatch(getTicketDetails(payload)).then((res) => {
        
        if (res?.status === 201 || res?.status === 200) {
          if (res?.data && res?.data != null) {
            localStorage.setItem('faclityData', JSON.stringify(res.data?.facility))
            setPaymentData(res?.data)
            localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))
            setError('')
            setIsLoading(false)
          } else {
            setPaymentData(EMPTY_OBJECT)
            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            let errObject = { 
              payload: payload,
              error: res,
              errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
            }
            setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PaymentResponse.js-69`))
            setIsLoading(false)
          }
        } else {
          setPaymentData(EMPTY_OBJECT)
          // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          let errObject = { 
            payload: payload,
            error: res,
            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
          }
          setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PaymentResponse.js-69`))
          setIsLoading(false)
        }
      }).catch((err) => {
        setPaymentData(EMPTY_OBJECT)
        setError(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        let errObject = { 
          payload: payload,
          error: err,
          errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
        }
        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PaymentResponse.js-69`))
        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        setIsLoading(false)
      })
    }


    // const daysHoursLength = convertHoursToDaysMinutes(Number(Details?.length))
    // setHoursToDays(daysHoursLength)
  }, [EMPTY_ARRAY])



  // modal confirmation

  return (

    <div className={`${paymentData?.ticket_number ? '' : 'main'} PaveConfirmation`}>
      <MiniHeader isDisplayBack title={'DETAILS'} />
      {/* <h4 className='headerParking my-3 text-info'>Confirmation</h4> */}
      {partner ?
        isLoading ? <Loader/> : paymentData?.ticket_number ? <>
          {paymentData?.facility?.photos?.url ? <img className='d-block mx-auto' style={{maxWidth:'400px'}} src={paymentData?.facility?.photos?.url} alt="Facility" /> : null}
          <div className='w-100 p-3 bg-primary text-white h-50  d-flex justify-content-between align-items-center'>
           <p className='mb-0'>{moment(paymentData?.check_in_datetime).format('dddd, MMMM D, YYYY')}</p>
            <a href={getLocation(paymentData?.facility)} target="_blank" rel="noreferrer"><span className='direction'>{getSvgIcon('share', '#ffffff')}</span></a>{/* <img src={direction} alt="Direction" className='direction'/> */}
          </div>


            <div className='border-top border-bottom '>
              <Row className='align-items-center g-0 '>
              <Col className='text-center p-2 border-end'>
                  <span className='text-sm fw-bold mb-1 d-block'>Start</span>
                  <small className=''>{moment(paymentData?.check_in_datetime).format('MM/DD/YYYY hh:mm A')}</small>
                </Col>
                <Col className='text-center p-2'>
                  <span className='text-sm fw-bold mb-1 d-block'>End</span>
                  <small className=''>{moment(paymentData?.checkout_datetime).format('MM/DD/YYYY hh:mm A')}</small>
                </Col>
          

              </Row>
            
             
            </div>
  
          <div className='p-3 pb-0 px-4'>
          <h6 className='text-primary mb-2 fw-bold'>Ticket Details</h6>
            <div className='border rounded p-3 bg-secondary bg-opacity-10'>
              <div className='d-flex justify-content-between '>
                <div>Ticket Number</div>
                <div>{paymentData?.ticket_number}</div>
              </div>
                 <div className='d-flex justify-content-between '>
                <div>Duration</div>
                <div>{paymentData?.total_length ? `${paymentData?.total_length?.replace('.', ':')}${paymentData?.total_length > 1 ? ' Hrs' : ' Hr'}` : '-'}</div>
              </div>
                 <div className='d-flex justify-content-between '>
                <div>License Plate</div>
                <div>{paymentData?.license_plate}</div>
              </div>
            </div>
          </div>
          <hr/>
          <div className=' px-4 '>
            <Row className=' justify-content-between align-items-center g-0'>
              <Col>
              <p className='fw-bold mb-0'>{`${paymentData?.facility?.full_name}`}</p>
                <span>{`${paymentData?.facility?.entrance_location}`}</span></Col>
                <Col className='col-auto'>
                <QRCode
                  value={ paymentData?.reservation?.ticketech_code ? paymentData?.reservation?.ticketech_code : isPromoValidateButton(paymentData, ['2', '3']) ? `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revpartnerUrl : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.pcipartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${paymentData?.ticket_number}` : paymentData?.ticket_number}
                  size="80"
                />
                   {/* <small className='textColorText text-center'>{messageSuccessPayment}</small> */}
                </Col>
              
            </Row>
            
           
            </div>

            <hr/>
            <div className=' px-4'>
            <div className='row align-items-center g-2'>
              <div className='col'>
              <span className='fw-medium text-primary'>Status</span>
              </div>
              <div className='col-auto text-end'>
                <p className='text-sm text-primary mb-0'>Paid </p>
              </div>
              <div className="col-auto">
              <i className="fa-regular fa-circle-check text-primary"></i>            </div>
            </div>
          </div>
          <hr/>
          {paymentData?.card_last_four ? <div className=' px-4'>
          <h6 className='text-primary mb-2 fw-bold'>Payment Method</h6>
           
            <div className='card p-3 d-flex flex-row justify-content-between align-items-center'>
                <div>
                  <img src={getCardIcon(paymentData?.card_type)}  style={{maxWidth:'60px'}} />
                  <span className='mx-3'>{`Card ending in ${paymentData?.card_last_four}`}</span>
                </div>
                <span className='fw-semibold'><span className='d-inline-flex' style={{ height: '25px', width: '25px' }}>{getSvgIcon('CheckMark', 'var(--bs-primary)')}</span></span>
            </div>
            </div> : null}
            {paymentData?.card_last_four ? <hr/> : null}
            <div className=' px-4'>
       
              <div className={(!priceGreaterOrNot(paymentData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
                {/* {priceGreaterOrNot(paymentData) && <p className='text-primary my-2 fw-semibold py-1 ps-3 bg-primary bg-opacity-10' >Price Breakup</p>} */}
                <PaymentBreakUpDetails
                  paymentData={paymentData}
                  breakDownTitle="Price Breakup"
                  className='py-2 d-flex'
                  sectionKey={((paymentData?.payable_amount != '0.00') && paymentData?.payable_amount) ? '' : 'paymantResponse'}
                  isDisplayDetails={true}
                  setIsDisplayDetails={setIsDisplayDetails}
                  isExtendDetails
                />
                <div className="card-footer">
                  <AmountPaid
                    className="bg-primary py-2 my-2 px-3"
                    paymentData={paymentData}
                    paybleText="Amount Due"
                    sectionKey={((paymentData?.payable_amount != '0.00') && paymentData?.payable_amount) ? '' : 'paymantResponse'}
                    setIsDisplayDetails={setIsDisplayDetails}
                    isInfo
                    hideTaxIncluded
                  />
                </div>
              </div>
              </div>
  




        </> : <NoData message={errorMsg} />
        : <NoData message={errorMessage?.invalidPartner} />}
      <PaymentBreakUpDetails
        className="my-2 m-2 d-flex justify-content-between"
        paymentData={paymentData}
        sectionKey={((paymentData?.payable_amount != '0.00') && paymentData?.payable_amount) ? '' : 'paymantResponse'}
        isDisplayDetails={isDisplayDetails}
        setIsDisplayDetails={setIsDisplayDetails}
      />

      <Footer />

    </div>
  )
}

ReceiptsDetails.propTypes = {
  dispatch: PropTypes.func,
  isFetching: PropTypes.bool,
  notify: PropTypes.func,
  loader: PropTypes.bool,
}

ReceiptsDetails.defaulProps = {
  dispatch: noop,
  isFetching: false,
  notify: noop,
  loader: false,
}

function mapStateToProps({ transientReducer }) {
  return {
    loader: transientReducer?.loader,
    isFetching: transientReducer?.isFetching
  }
}

export default connect(mapStateToProps)(ReceiptsDetails)
